import { getDefaultFileEditorState } from './reducers';
import { FileEditorsState, FileEditorState } from './typings';

export const selectFileEditorState = (editors: FileEditorsState, editorId: string): FileEditorState => {
    return editors[editorId] || getDefaultFileEditorState();
};
